<template>
    <v-sheet class="px-4 px-lg-0 bg-transparent">
        <back-to-home />
        <page-title :title="t('issuesForm.formBase.title')" />
        <issues-new-submit :initial-form-type="formTypeFromQuery" />
    </v-sheet>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IssuesNewSubmit from '@/features/issuesPage/components/Submit/list/IssuesNewSubmit.vue';
import { BackToHome, PageTitle } from '@/features/common/components/page';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const { t } = useI18n();
const route = useRoute();

const formTypeFromQuery = computed(() => route.query.type as string | undefined);
</script>
